export const propPanel = {
    schema: ({ i18n }) => {
        return {
            section: {
                title: i18n('schemas.section'),
                type: 'string',
                widget: 'Input',
                span: 24,
                required: true,
            },
            appRender: {
                type: 'object',
                properties: {
                    label: {
                        title: i18n('schemas.label'),
                        type: 'string',
                        widget: 'Input',
                        span: 24,
                        required: true,
                    },
                    buttons: {
                        title: 'Buttons',
                        type: 'array',
                        widget: 'ButtonCounterWidget',
                        span: 24,
                        required: true,
                    },
                }
            }
        };
    },
    defaultSchema: {
        name: '',
        rotate: undefined,
        type: 'CheckBox',
        position: { x: 10, y: 10 },
        width: 24,
        height: 24,
        appRender: {
            label: "",
            buttons: [
                { id: 1, label: "Option 1", checked: false },
                { id: 2, label: "Option 2", checked: false },
                { id: 3, label: "Option 3", checked: false },
            ]
        },
    },
};
//# sourceMappingURL=propPanel.js.map